import React from 'react';

export const QuizIntroduction = ({ onPlayStarted }) => {

    const handlePlay = (e) => {
        if(onPlayStarted) {
            onPlayStarted(e);
        }
    }

    return (
        <>
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">Quiz title</h3>
                </div>
                <div className="panel-body">
                    Quiz Intro
                </div>
                <div className="panel-footer">
                    <button className="btn btn-default" onClick={handlePlay}>Play</button>
                </div>
            </div>
        </>
    )
}